import { render, staticRenderFns } from "./BsAdapt.vue?vue&type=template&id=14ef712c&scoped=true&"
import script from "./BsAdapt.vue?vue&type=script&lang=js&"
export * from "./BsAdapt.vue?vue&type=script&lang=js&"
import style0 from "./BsAdapt.vue?vue&type=style&index=0&id=14ef712c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef712c",
  null
  
)

export default component.exports